import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const userRegisteredGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.userRegistrationStatus.pipe(
        filter((status) => status !== 'unknown'),
        take(1),
        map((status) => status === 'registered' || router.createUrlTree(['/account-pending']))
    );
};

export const accountPendingGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.userRegistrationStatus.pipe(
        filter((status) => status !== 'unknown'),
        take(1),
        map((status) => status === 'not_registered' || router.createUrlTree(['/players/dashboard']))
    );
};
